<template>
  <portal :to="destination">
    <div class="gg">
      <Animation
        v-show="moving"
        :play="moving"
        :loop="false"
        :speed="1"
        :direction="moveDirection"
        animation="portal"
        class="gg__portal"
      />
      <transition
        name="fade"
        @after-enter="fight"
        @before-leave="playTeleport"
        @after-leave="move"
      >
        <Character v-show="visible" :character="player" class="gg__character" />
      </transition>
    </div>
  </portal>
</template>

<script>
import { mapState } from "vuex";
import Animation from "./Animation";
import Character from "./Character";

export default {
  components: { Animation, Character },
  computed: {
    ...mapState(["player"]),
    bonus() {
      return this.player.floor.character === "littlebigplanet";
    },
    visible() {
      return ["movingOut", "none"].indexOf(this.player.state) !== -1;
    },
    moving() {
      return this.player.state.startsWith("moving");
    },
    moveDirection() {
      return this.player.moving === "in" ? 1 : -1;
    },
    destination() {
      return `${this.player.towerId}:${this.player.floorId}`;
    }
  },
  methods: {
    playTeleport() {
      if (!this.player.destination) return;
      this.$events.emit("playSound", "teleport");
    },

    fight() {
      if (this.player.towerId === -1) return;

      if (!this.bonus) {
        this.$events.emit("playSound", "fight");
      }

      this.$store.dispatch("player/fight");
    },

    move() {
      this.$store.dispatch("player/move");
    }
  }
};
</script>

<style lang="scss" scoped>
.gg {
  height: vh(11);
  cursor: pointer;
  position: relative;

  &__character {
    width: 100%;
  }

  &__portal {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
